// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width: 2200px){
    header{
        height: 8rem;
    }

    header nav{
        font-size: 1.3rem;
    }
}

@media screen and (min-width: 1921px) and (max-width: 2200px){
    header{
        height: 7rem;
    }

    header nav{
        font-size: 1.15rem;
    }
}

@media screen and (max-width: 1920px){
    header nav{
        font-size: 1rem;
    }
}

@media screen and (max-width: 1200px){
    header nav ul{
        font-size: 0.9em;
    }
}



/* CSS para menuToggle no navbar */


@media screen and (max-width: 860px) {
    .visibility{
        display: block;
    }

    nav{
        justify-content: space-between;
    }

    header nav ul, .container-user-info{
        display: none;
    }

    .opened-menu{
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 10;
        background-color: blueviolet;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .opened-menu ul{
        height: 30vh;
        display: flex;
        flex-direction: column;
        justify-content:space-around;
        align-items: center;
        
    }

    .opened-menu .menu-toggle{
        position: absolute;
        right: 20px;
        top: 20px;
    }

    .opened-menu ul li .navbar-items{
        color: #FFFFFF;
        transition-duration: 0.5s;
        font-size: 2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/responsive/NavBar-responsive.css"],"names":[],"mappings":"AAAA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;;;AAIA,kCAAkC;;;AAGlC;IACI;QACI,cAAc;IAClB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,YAAY;QACZ,aAAa;QACb,WAAW;QACX,4BAA4B;QAC5B,aAAa;QACb,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,4BAA4B;QAC5B,mBAAmB;;IAEvB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;IACb;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,eAAe;IACnB;AACJ","sourcesContent":["@media screen and (min-width: 2200px){\n    header{\n        height: 8rem;\n    }\n\n    header nav{\n        font-size: 1.3rem;\n    }\n}\n\n@media screen and (min-width: 1921px) and (max-width: 2200px){\n    header{\n        height: 7rem;\n    }\n\n    header nav{\n        font-size: 1.15rem;\n    }\n}\n\n@media screen and (max-width: 1920px){\n    header nav{\n        font-size: 1rem;\n    }\n}\n\n@media screen and (max-width: 1200px){\n    header nav ul{\n        font-size: 0.9em;\n    }\n}\n\n\n\n/* CSS para menuToggle no navbar */\n\n\n@media screen and (max-width: 860px) {\n    .visibility{\n        display: block;\n    }\n\n    nav{\n        justify-content: space-between;\n    }\n\n    header nav ul, .container-user-info{\n        display: none;\n    }\n\n    .opened-menu{\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100vw;\n        height: 100vh;\n        z-index: 10;\n        background-color: blueviolet;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n    }\n\n    .opened-menu ul{\n        height: 30vh;\n        display: flex;\n        flex-direction: column;\n        justify-content:space-around;\n        align-items: center;\n        \n    }\n\n    .opened-menu .menu-toggle{\n        position: absolute;\n        right: 20px;\n        top: 20px;\n    }\n\n    .opened-menu ul li .navbar-items{\n        color: #FFFFFF;\n        transition-duration: 0.5s;\n        font-size: 2rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
